var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49998 11.8684C1.49499 11.1958 0.833313 10.0501 0.833313 8.74992C0.833313 6.79692 2.32624 5.19266 4.2331 5.01606C4.62315 2.64336 6.68351 0.833252 9.16665 0.833252C11.6498 0.833252 13.7101 2.64336 14.1002 5.01606C16.0071 5.19266 17.5 6.79692 17.5 8.74992C17.5 10.0501 16.8383 11.1958 15.8333 11.8684M5.83331 11.6666L9.16665 8.33325M9.16665 8.33325L12.5 11.6666M9.16665 8.33325V15.8333",
    stroke: "#209DFA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBlue);
export default __webpack_public_path__ + "static/media/upload_icon_blue.807688989d401780f49b724cd82d9ecf.svg";
export { ForwardRef as ReactComponent };